module.exports = __webpack_public_path__ + "static/Luca-Camerini-f488b37437555eb6788beb3197a1d839.jpg";